import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'homi-data-list-label',
  templateUrl: 'data-list-label.component.html',
  styleUrls: ['data-list-label.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataListLabelComponent {}
